// Ordered list of subcategories for the interest picker (excludes vague parent/catch-all names)
export const INTEREST_CATEGORIES: { label: string; emoji: string }[] = [
  { label: 'Electronics',            emoji: '🔌' },
  { label: 'Computers & Accessories',emoji: '🖥️' },
  { label: 'Phones & Accessories',   emoji: '📱' },
  { label: 'Gaming',                 emoji: '🎮' },
  { label: 'TV & Audio',             emoji: '📺' },
  { label: 'Smart Home',             emoji: '💡' },
  { label: 'Appliances',             emoji: '🫧' },
  { label: 'Snacks & Candy',         emoji: '🍿' },
  { label: 'Coffee & Tea',           emoji: '☕' },
  { label: 'Beverages',              emoji: '🥤' },
  { label: 'Cooking & Baking',       emoji: '🍳' },
  { label: 'Skincare',               emoji: '🧴' },
  { label: 'Makeup & Cosmetics',     emoji: '💄' },
  { label: 'Hair Care',              emoji: '💇' },
  { label: 'Vitamins & Supplements', emoji: '💊' },
  { label: 'Personal Care',          emoji: '🪥' },
  { label: 'Fragrances',             emoji: '🌸' },
  { label: 'Home & Kitchen',         emoji: '🏠' },
  { label: 'Furniture',              emoji: '🛋️' },
  { label: 'Bedding & Bath',         emoji: '🛁' },
  { label: 'Garden & Outdoor',       emoji: '🌿' },
  { label: 'Cleaning Supplies',      emoji: '🧹' },
  { label: 'Tools & Hardware',       emoji: '🔧' },
  { label: 'Clothing & Apparel',     emoji: '👕' },
  { label: 'Shoes & Footwear',       emoji: '👟' },
  { label: 'Jewelry & Accessories',  emoji: '💍' },
  { label: 'Sports & Fitness',       emoji: '🏋️' },
  { label: 'Books, Music & Movies',  emoji: '📚' },
  { label: 'Toys & Games',           emoji: '🧸' },
  { label: 'Baby & Kids',            emoji: '🍼' },
  { label: 'Pet Supplies',           emoji: '🐾' },
  { label: 'Automotive',             emoji: '🚗' },
  { label: 'Alcohol, Beer & Wine',   emoji: '🍷' },
  { label: 'Breakfast & Cereal',     emoji: '🥣' },
  { label: 'Bakery & Bread',         emoji: '🍞' },
  { label: 'Dairy & Eggs',           emoji: '🥛' },
  { label: 'Meat, Poultry & Seafood',emoji: '🥩' },
  { label: 'Produce & Fresh Food',   emoji: '🥦' },
  { label: 'Frozen Foods',           emoji: '🧊' },
  { label: 'Canned & Packaged Goods',emoji: '🥫' },
  { label: 'Condiments & Sauces',    emoji: '🫙' },
  { label: 'International Foods',    emoji: '🌍' },
  { label: 'Office Supplies',        emoji: '📎' },
];

export const CATEGORY_EMOJI: Record<string, string> = {
  // ── Parent categories ──────────────────────────────────────────────────
  'Electronics & Tech':  '💻',
  'Entertainment':       '🎬',
  'Fashion':             '👗',
  'Food & Drink':        '🍽️',
  'Health & Beauty':     '💅',
  'Home':                '🏡',
  'Everything Else':     '🗂️',

  // ── Electronics & Tech ────────────────────────────────────────────────
  'Appliances':               '🫧',
  'Computers & Accessories':  '🖥️',
  'Electronics':              '🔌',
  'Gaming':                   '🎮',
  'Phones & Accessories':     '📱',
  'Smart Home':               '💡',
  'TV & Audio':               '📺',

  // ── Entertainment ─────────────────────────────────────────────────────
  'Books, Music & Movies':    '📚',
  'Toys & Games':             '🧸',

  // ── Fashion ───────────────────────────────────────────────────────────
  'Clothing & Apparel':       '👕',
  'Jewelry & Accessories':    '💍',
  'Shoes & Footwear':         '👟',

  // ── Food & Drink ──────────────────────────────────────────────────────
  'Alcohol, Beer & Wine':     '🍷',
  'Bakery & Bread':           '🍞',
  'Beverages':                '🥤',
  'Breakfast & Cereal':       '🥣',
  'Canned & Packaged Goods':  '🥫',
  'Coffee & Tea':             '☕',
  'Condiments & Sauces':      '🫙',
  'Cooking & Baking':         '🍳',
  'Dairy & Eggs':             '🥛',
  'Frozen Foods':             '🧊',
  'International Foods':      '🌍',
  'Meat, Poultry & Seafood':  '🥩',
  'Produce & Fresh Food':     '🥦',
  'Snacks & Candy':           '🍿',

  // ── Health & Beauty ───────────────────────────────────────────────────
  'Fragrances':               '🌸',
  'Hair Care':                '💇',
  'Makeup & Cosmetics':       '💄',
  'Personal Care':            '🪥',
  'Skincare':                 '🧴',
  'Vitamins & Supplements':   '💊',

  // ── Home ──────────────────────────────────────────────────────────────
  'Bedding & Bath':           '🛁',
  'Cleaning Supplies':        '🧹',
  'Furniture':                '🛋️',
  'Garden & Outdoor':         '🌿',
  'Home & Kitchen':           '🏠',
  'Tools & Hardware':         '🔧',

  // ── Everything Else ───────────────────────────────────────────────────
  'Automotive':               '🚗',
  'Baby & Kids':              '🍼',
  'Office Supplies':          '📎',
  'Pet Supplies':             '🐾',
  'Sports & Fitness':         '🏋️',
  'Other':                    '📦',
};
